import React from "react";
import InvoiceNotes from "./InvoiceNotes";
import Charges from "./Charges";

export default () => {
    return (
            <div className="notes_table_div">
                <div className="row notes_and_charges_info">
                   <InvoiceNotes/>
                    <Charges/>
                </div>
            </div>
    )
}
